// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.top-container {
  height: 20%;
  display: flex;
  justify-content: space-between;
}
.top-container #title {
  font-size: xx-large;
  font-weight: bold;
}
.top-container #mat-close-btn {
  height: 36px;
  width: 20px;
  border: none;
  background-color: inherit;
}
.top-container #mat-close-btn fa-icon {
  color: #707070;
}

.lower-container {
  height: 20%;
}
.lower-container .btn-divider {
  width: 2%;
  height: auto;
  display: inline-block;
}
.lower-container button {
  display: inline-block;
  width: 49%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
